// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/ausbildungsstart-2021/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const ausbildungsstart2021DE: PageEntry = {
  id: "post.ausbildungsstart-2021",
  locale: "de",
  slug: "ausbildungsstart-2021",
  seo: {
    title: "Ausbildungsstart 2021 | Dietz GmbH",
    description: "Ausbildungsstart 2021",
  },
  type: "post",
  h1: "Ausbildungsstart 2021",
  blocks: [
    { kind: "heading", level: 2, text: "Ausbildungsstart 2021" },
    { kind: "paragraph", text: "Heute am 1. September starten insgesamt acht neue Auszubildende ihre Ausbildung bei Dietz: Industriemechaniker*innen, Werkzeugmechaniker*innen, Technische Produktdesigner*innen, Industriekaufleute und Fachlagerist*innen." },
    { kind: "paragraph", text: "Um 7.30 Uhr begrüßten wir unsere neuen Kolleg*innen und überreichten die Willkommenspakete. Im Anschluss folgten allerhand Informationen rund um die Ausbildung und den Arbeitsalltag/-ablauf bei Dietz. Neben einem Betriebsrundgang soll es heute im weiteren Verlauf jedoch primär um das Kennenlernen des Unternehmens und der Azubis untereinander gehen." },
    { kind: "paragraph", text: "Die gesamte Dietz-Familie wünscht allen Durchstarter*innen eine ereignisreiche, spannende und informative erste Woche – wir freuen uns auf die gemeinsame Zukunft mit euch!" },
    { kind: "paragraph", text: "Wer sich über freie Ausbildungsplätze 2022 informieren möchte, kann gerne unter https://www.dietz.eu/karriere/schueler/ vorbeischauen." }
  ],
};
